import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { StoreOwner } from '@/services/storeOwner/storeOwner.types';
import { OwnerTableActionBar } from './ActionBar';
import { getColumns } from './Column';

export function OwnersTable({
  data,
  isLoading,
  pagination,
}: {
  data: StoreOwner[];
  isLoading?: boolean;
  pagination: Pagination;
}) {
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);

  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: t('userManagement.storeOwners.table.title'),
      loading: isLoading,
      totalPage: pagination.totalItems,
    },
    getRowId: (originalRow) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
        <OwnerTableActionBar />
      </DataTable>
    </>
  );
}
